// если импортировать тему как обычно, то линария падает при попытке схавать ее внутри css``. Иначе импортировать не получилось
import {slugify} from '@linaria/utils'
import {fromEntries, map, pipe, toEntries} from '@logistics-frontend/utils'

import lightTheme from '../../../../node_modules/@gwc/core/dist/cjs/themes/light'
import type {CSSProperties} from '../../theme/css'

export const deliveryTheme = {
  ...lightTheme,
  colors: {
    ...lightTheme.colors,
    deliveryGrey: {
      100: '#E6E6E6',
      125: '#DDDCDA',
      150: '#D4D4D0',
      200: '#B3B3B3',
      250: '#999999',
      300: '#808080',
      350: '#666666',
      400: '#4D4D4D',
      450: '#333333',
      500: '#252525',
      550: '#1A1A1A',
    },
    boxBrown: {
      50: '#FBF7F3',
      75: '#F9F1EB',
      100: '#F5EAE1',
      150: '#F0DDCE',
      200: '#F0DCCC',
      250: '#E8CAB2',
      300: '#E5B68F',
      500: '#D29C6F',
    },
    deliveryWidget: {
      green: '#E7F4E0',
      red: '#FFCEBE',
    },
  },
}

// fixme костыли. CSSProperties нужен чтобы линария не ругалась на интерполяцию, инстанс String для ссылочного значения, остальное - публичный интерфейс
// придумывать как сделать некостыльно имеет смысл после апгрейда линарии
type Var<Value extends string | undefined = string> = CSSProperties & String & {token: string; hex: Value}

type ThemeVars<T> = {
  [Key in keyof T]-?: T[Key] extends string | number | undefined
    ? Var<Extract<T[Key], string | undefined>>
    : T[Key] extends object
    ? ThemeVars<T[Key]>
    : T[Key]
}

const wrapVar = <Value extends string | undefined>(token: string, hex: Value) => {
  // Здесь нам нужна именно ссылочная строка, чтобы ее правильно обрабатывала линария И можно было впихнуть доп свойства
  // eslint-disable-next-line no-new-wrappers
  const result: Var<Value> = new String(`var(${token},${hex || ''})`) as Var<Value>
  result.token = token
  result.hex = hex
  return result
}

const toFigmaKeys = ({
  colorScheme: {bgMinor, bgInvert, ...colorScheme},
  ...themeRest
}: ThemeVars<typeof deliveryTheme>) => ({
  ...themeRest,
  default: {
    day: {
      ...colorScheme,
      backgroundMinor: bgMinor,
      backgroundInvert: bgInvert,
    },
  },
})

const toVars = <T>(sourceTheme: T, prefix = ''): ThemeVars<T> => {
  return pipe(
    sourceTheme,
    toEntries,
    map(([key, value]) => {
      switch (typeof value) {
        case 'string':
          return [key, wrapVar(`--${prefix}${key}`, value)]
        case 'object':
          return [key, toVars(value, `${prefix}${key}-`)]
        case 'number':
          return [key, wrapVar(`--${prefix}${key}`, `${value}px`)]
        default:
          return [key, value]
      }
    }),
    fromEntries,
  ) as ThemeVars<T>
}

export const cssTheme = pipe(deliveryTheme, toVars, toFigmaKeys)

const cssVars: Record<string, boolean> = {}

export const createCssVar = (
  keyName: string,
  defaultValue?: string,
): [string, (value: Var | string) => Record<string, Var | string>, string] => {
  const key = `--${keyName}`
  if (key in cssVars) {
    return createCssVar(`${keyName}_${slugify(keyName)}`, defaultValue)
  }
  cssVars[key] = true

  const setVar = (value: Var | string) => ({[key]: value})
  const defaultValueStr = !!defaultValue ? `, ${defaultValue}` : ''

  return [`var(${key}${defaultValueStr})`, setVar, key]
}
